import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({ baseUrl: "", credentials: 'include' })


export const apiSlice = createApi({
    baseQuery,
    tagTypes: [
        'bankAccounts', 'FbrHsCode', 'inventory', 'purchaseinvoices', 'saleinvoices', 
        'products', 'vendors', 'customers', 'warehouses', 'productquantity',
        'zones', 'towns', 'salemans', 'brands', 'categories', 'packtypes', 'producttypes', 'subcategories', 'units'
    ],

    endpoints: (builder) => ({})
});